import React from 'react';
import {Heading, Box, VStack, HStack, Text, View} from 'native-base';
import {BolivarIcon, DollarIcon} from '../../../../../../components/icons';
import IInvoiceFeeSummary from '../../../../../../interfaces/dtos/invoice-fee-summary.interface';
import {formatMoney} from '../../../../../../utils/format';
import {message as t} from '../../../../../../utils/messages';

interface IHeaderProps {
  detail: IInvoiceFeeSummary;
}

const HeaderSection = (props: IHeaderProps) => {
  const {detail} = props;

  return (
    <Box paddingX={8}>
      <VStack flex={1}>
        <HStack space={5}>
          <VStack justifyContent="center" space="0" flex={1}>
            <Box height="6" justifyContent="center">
              <Heading size="sm" fontWeight="medium" color="#4C4C4C">
                {detail.id}
              </Heading>
            </Box>
            <Box justifyContent="center" marginTop={1}>
              <Text color="#99A2B4" fontSize={'sm'} numberOfLines={3}>
                {`${detail.type.label}: ${detail.summary}`}
              </Text>
            </Box>
          </VStack>
          <HStack w="110" justifyContent="center">
            <VStack justifyContent="center" space="1">
              <Box height="6" justifyContent="center">
                <DollarIcon />
              </Box>
              <Box height="6" justifyContent="center" marginTop={1}>
                <BolivarIcon />
              </Box>
            </VStack>
            <VStack space="1" w={'110'} justifyContent="center">
              <View
                height="6"
                alignItems="flex-end"
                paddingLeft="2"
                justifyContent="center">
                <Text fontWeight="bold" color="#06355E" fontSize="md">
                  {formatMoney(detail.amount.foreign, '')}
                </Text>
              </View>
              <Box
                height="6"
                alignItems="flex-end"
                paddingLeft="2"
                justifyContent="center"
                marginTop={1}>
                <Text fontWeight="bold" color="#06355E" fontSize="md">
                  {formatMoney(detail.amount.local, '')}
                </Text>
              </Box>
            </VStack>
          </HStack>
        </HStack>
        <HStack
          backgroundColor={'blueGray.200'}
          marginTop={4}
          marginBottom={5}
          padding={1}
          justifyContent={'center'}>
          <Text color={'blueGray.700'}>
            {t('unpaided-fee-selection-header-info')}
          </Text>
        </HStack>
      </VStack>
    </Box>
  );
};
export default HeaderSection;
